module.exports = __webpack_public_path__ + "static/media/twitter_logo.321aa579.jpg";